export default function setCurrentConfig(bundles) {
    return Object.keys(bundles).map((bundleKey) => {
        const { data } = bundles[bundleKey];
        if (data["value"] && !Array.isArray(data["value"])) {
            data["value"] = [data["value"]];
        }
        return {
            ...data,
            id: bundleKey,
        };
    });
}
//# sourceMappingURL=setCurrentConfig.js.map